export const CREATE_BATCH = 'CREATE_BATCH'
export const EXTRACT_ITEM = 'EXTRACT_ITEM'
export const PATCH_ITEM = 'PATCH_ITEM'
export const SET_PROGRAMME_MAPPING = 'SET_PROGRAMME_MAPPING'
export const CREATE_PRODUCT = 'CREATE_PRODUCT'
export const FETCH_ISSUER_PROGRAMS = 'FETCH_ISSUER_PROGRAMS'
